import { Card, Table, Button } from "react-bootstrap";
import { startTransition, useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useLazyGetPlatformUsersQuery } from "app/redux/Users/Accessusers/accessUsersApi";
import {ArrowLeftCircle} from "react-bootstrap-icons";
import { toast } from "react-toastify";
import useFullPageLoader from "app/hooks/useFullPageLoader ";

export default function PlatformUsers() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const dispatch = useDispatch();
  const { selectedCompanyId } = useSelector((state) => state.company);
  const [getPlatformUsers] = useLazyGetPlatformUsersQuery();
  let fullPlatFormUserList = useSelector((state) => {
    return state.accessUser.platformUserList;
  });
  const [platFormUserListData, setPlatFormUserListData] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if(!fullPlatFormUserList || fullPlatFormUserList.length <= 0){
        getPlatFormUserList();
    }
    else{
        setPlatFormUserListData(fullPlatFormUserList);
    }
  }, []);

  const getPlatFormUserList = () => {
    showLoader();
    getPlatformUsers({
      UserRoleId: 0,
      CompanyId: selectedCompanyId,
      type: "userlistdepartmentwise",
    }).then((result) => {
      hideLoader();
      if (result.data.data?.length > 0) {
        fullPlatFormUserList = result.data.data;
        setPlatFormUserListData(fullPlatFormUserList);
      }
     }, error => {
        hideLoader();
        console.log('edit error', { autoClose: 2000 });
        toast.error(error);
    });
  }

  const handleSearch = (event) => {
    let tempFullPlatFormUserListData = fullPlatFormUserList;
    event.persist();
    setInputValue(event.target.value);
    startTransition(() => {
      const filterSearch = tempFullPlatFormUserListData.filter((item) =>
        (item.UserName && item.UserName.toLowerCase().match(event.target.value.toLowerCase())) ||
        (item.Epost && item.Epost.toLowerCase().match(event.target.value.toLowerCase())) 
      );
      setPlatFormUserListData(filterSearch);
    });
  };

  const concatArrayStrings = (arrayElem) => {
    if (arrayElem) {
        const data = arrayElem.map(e => e.Name).join(', ');
        return data;
    }
    else {
        return null;
    }
}
  

  return (
    <Fragment>
      {
        <div>
        <div className="row mb-2" style={{alignItems: "baseline"}}>
                <div className="col-md-2">
                    <h1>Administratorer</h1>
                </div>
                
                <div className="col-md-10 text-md-end">
                    <Link to="/">
                    <Button className="mb-3" variant="primary">
                        <ArrowLeftCircle className={'me-2'} size={17}></ArrowLeftCircle>
                        Tilbake
                    </Button>
                    </Link>
                </div>
        </div>
        <div >
            <input
            autoFocus
            type="text"
            placeholder="Søk navn, e-post, telefon"
            className="input-search-inputCustom"
            onChange={handleSearch}
            value={inputValue}
            />
        </div>

        <Card elevation={6} className="w-100 overflow-auto">
            <Table
            bordered
            className="table table-bordered tbl-custom"
            style={{ minWidth: 750 }}
            >
            <thead style={{borderTop: "1px solid #eeeeee", whiteSpace: "nowrap"}}>
                <tr>
                    <th className="py-3" align="left">
                        Navn
                    </th>
                    <th className="py-3" align="left">
                        Organisasjon
                    </th>
                    <th className="py-3" align="left">
                        Brukkerrolle(r)
                    </th>
                    <th className="py-3" align="left">
                        Tlf
                    </th>
                    <th className="py-3" align="left">
                        Epost
                    </th>
                    <th className="py-3" align="left">
                        Sist pålogget
                    </th>
                </tr>
            </thead>

            {platFormUserListData.map((item, index) => (
                <tbody key={index}>
                <tr>
                    <td className="py-3 capitalize" align="left">
                        {item.UserName} 
                    </td>
                    <td className="py-3 capitalize" align="left">
                        {concatArrayStrings(item.OrgUnit)}
                    </td>
                    <td className="py-3 capitalize" align="left">
                        {item.UserRole}
                    </td>
                    <td align="left">
                        {item.PhoneNumber}
                    </td>
                    <td align="left">
                        {item.UserEmail}
                    </td>
                </tr>
                </tbody>
            ))}
            </Table>
        </Card>
        
        </div>
    }
  
    {loader}
    </Fragment>
    
  );
}

